import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import * as Prism from 'prismjs';
import { Subscription } from 'rxjs';
import { ConstantsCLA } from '../shared/constants-cla';
import { InstructorOrTutorDTO, StudenteDTO, UtenteDTO } from './newModel';

export abstract class AbstractBaseComponent
  implements OnDestroy, OnInit, AfterViewInit {
  instructor: InstructorOrTutorDTO;
  tutor: InstructorOrTutorDTO;
  student: StudenteDTO;
  currentUser: UtenteDTO;
  modalSubscribe: Subscription;
  isTutor: boolean;
  isInstructor: boolean;
  idUtenteOperazione: number;
  nomeCompletoUtenteOperazione: string;
  isStudente: boolean;
  backEndUrl: string;

  constructor() {
    this.backEndUrl = ConstantsCLA.URL_BACK_END_CLA;
  }

  ngOnDestroy(): void {
    if (this.modalSubscribe) {
      this.modalSubscribe.unsubscribe();
    }
  }

  ngAfterViewInit() {
    Prism.highlightAll();
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    if (!!this.currentUser) {
      if (!this.currentUser.tipoStudente) {
        this.instructor = this.currentUser.instructorOrTutor;
        this.tutor = this.currentUser.instructorOrTutor;
        this.isTutor = this.currentUser.gruppo.nome === 'TUTOR';
        this.isInstructor = this.currentUser.gruppo.id === 2;
        this.nomeCompletoUtenteOperazione =
          this.instructor.cognome + ' ' + this.instructor.nome;
        this.idUtenteOperazione = this.instructor.id;
        this.isStudente = false;
      }
      if (this.currentUser.tipoStudente) {
        this.student = this.currentUser.studente;
        this.isStudente = true;
        this.isInstructor = false;
        this.isTutor = false;
      }
    }
  }
}
